import Collection from '../../collection';
import UserTag from '../../model/refbooks/user.tag';

export default Collection.extend( {
	endpoint: 'users/tags/list?apiVersion=2.0&limit=1000000',
    model: UserTag
} );


// WEBPACK FOOTER //
// ./src/js/collection/refbooks/user.tags.js